import './collection-banner.scss';
